import { RunsExplorer } from '@/components/RunsExplorer'
import { adminCopy, runsCopy } from '@/copy'
import type { WorkspaceInfo } from '@/types/api'
import { EmptyState } from '@/ui/EmptyState/EmptyState'
import { SectionHeader } from '@/ui/SectionHeader/SectionHeader'

interface Props {
  wsId: string
  workspaces: WorkspaceInfo[]
  returnTo: string
}

/**
 * Admin view of run traces: the shared {@link RunsExplorer} for the workspace
 * chosen in the picker `AdminPage` sets above it, over *every* workspace. Members see the same explorer scoped to their own
 * workspace from the workspace Runs page — this tab exists only for the
 * cross-tenant view.
 *
 * The workspace selection is owned by `AdminPage` (shared with the Agents and
 * Usage tabs) so it survives this tab remounting when the user returns from a
 * run detail page.
 */
export function RunsTab({ wsId, workspaces, returnTo }: Props) {
  return (
    <section>
      <SectionHeader rule trailingSpacing="section">
        {adminCopy.runs.heading}
      </SectionHeader>
      {workspaces.length === 0 ? (
        <EmptyState variant="inline" description={adminCopy.noWorkspaces} />
      ) : (
        <RunsExplorer
          workspaceId={wsId}
          queryScope="admin"
          returnTo={returnTo}
          caption={runsCopy.caption.workspace}
        />
      )}
    </section>
  )
}
